import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { DataGridFlexSales, useDataGridFlexSales } from '../DataGridFlexSales';
import handlerFactory, { ManagementGridContext } from './handlerFactory';
import { ManagementReportEntry } from '../../state/managementReport/types';
import { AppState } from '../../state/index';

const DataGridConfig = () => {
  const { handler } = useDataGridFlexSales<ManagementReportEntry, ManagementGridContext>();
  const { t } = useTranslation();
  const reportResource = useSelector((state: AppState) => state.managementReport.report);
  const { loading, data } = reportResource;

  const gridContext = useMemo(() => ({ t }), [t]);

  handler.setData(data);
  handler.setContext(gridContext);
  handler.setTitle(t('management-report.title'));
  handler.setLoading(loading);

  return null;
};

const ManagementReportDataGrid = () => (
  <DataGridFlexSales handlerFactory={handlerFactory}>
    <DataGridConfig />
  </DataGridFlexSales>
);

export default ManagementReportDataGrid;
